import React, { useEffect, useState } from 'react';
import { usePrefersReducedMotion } from './useMediaQuery';

/**
 * PLACEHOLDER testimonials — replace with verified quotes from teammates before launch.
 * Edit copy here without touching JSX structure.
 */
export const PLACEHOLDER_TESTIMONIALS = [
  {
    quote:
      "The interview was the most technical conversation I'd had in years. They actually care if you can think.",
    attribution: 'Backend Engineer, joined 2024'
  },
  {
    quote:
      'I came in expecting another services company. What I found was a team that ships real products to real users.',
    attribution: 'Mobile Engineer, joined 2023'
  }
];

export const TESTIMONIAL_BLOCK_COPY = {
  blockTitle: "From the team you're about to meet"
};

const ROTATE_MS = 15000;
const FADE_MS = 600;

/**
 * @param {{ className?: string }} props
 */
export default function TestimonialCard({ className = '' }) {
  const reducedMotion = usePrefersReducedMotion();
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    if (reducedMotion || PLACEHOLDER_TESTIMONIALS.length < 2) return undefined;
    const id = window.setInterval(() => {
      setVisible(false);
      window.setTimeout(() => {
        setIndex((i) => (i + 1) % PLACEHOLDER_TESTIMONIALS.length);
        setVisible(true);
      }, FADE_MS);
    }, ROTATE_MS);
    return () => window.clearInterval(id);
  }, [reducedMotion]);

  const t = PLACEHOLDER_TESTIMONIALS[index];

  return (
    <section
      className={`cep-block cep-testimonial ${className}`.trim()}
      aria-labelledby="cep-testimonial-heading"
    >
      <h2 id="cep-testimonial-heading" className="cep-block__title">
        {TESTIMONIAL_BLOCK_COPY.blockTitle}
      </h2>
      <blockquote
        className={`cep-testimonial__card${visible ? ' cep-testimonial__card--visible' : ''}`}
        style={{ '--cep-fade-ms': `${FADE_MS}ms` }}
      >
        <span className="cep-testimonial__mark" aria-hidden="true">
          &ldquo;
        </span>
        <p className="cep-testimonial__quote">{t.quote}</p>
        <footer className="cep-testimonial__attr">{t.attribution}</footer>
      </blockquote>
      <div className="cep-testimonial__controls" role="group" aria-label="Testimonial">
        {PLACEHOLDER_TESTIMONIALS.map((_, i) => (
          <button
            key={i}
            type="button"
            className={`cep-testimonial__control${i === index ? ' cep-testimonial__control--active' : ''}`}
            aria-label={`Show testimonial ${i + 1}`}
            aria-current={i === index ? 'true' : undefined}
            onClick={() => {
              setIndex(i);
              setVisible(true);
            }}
          />
        ))}
      </div>
    </section>
  );
}
